import CheckBox from '@lib/components/CheckBox';
import ErrorMessage from '@lib/components/ErrorMessage';
import InputText, * as IInputText from '@lib/components/InputText';
import Selector from '@lib/components/Selector';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { TemperatureProps } from '@lib/containers/Temperature';
import { INativeNavigator, ITempChannel } from '@lib/types';
import { diffBetweenObject, isTemperaturInRange } from '@lib/util/util';
import * as React from 'react';
import './Temperature.css';




interface ITemperatureState {
  idDevice: string;
  temp: ITempChannel;
  isCalibrationError: boolean;
  isLabelError: boolean;
  isDeltaError: boolean;
  isThresholdUpError: boolean;
  isThresholdDownError: boolean;
  selectorShow: boolean;
  selectorProperty: string;
  selectorValue: number;
  selectorStep: number;
  selectorMin: number;
  selectorMax: number;
  selectorLabel: string;
  modified: boolean;
}

class Temperature extends React.Component<TemperatureProps, ITemperatureState> {

  public constructor(props: TemperatureProps) {
    super(props);
    this.state = {
      idDevice: this.props.idDevice,
      isCalibrationError: false, isDeltaError: false, isLabelError: false,
      isThresholdDownError: false, isThresholdUpError: false,
      modified: false,
      selectorLabel: '', selectorMax: 0, selectorMin: 0, selectorProperty: '', selectorShow: false, selectorStep: 0, selectorValue: 0,
      temp: JSON.parse(JSON.stringify(this.props.temp || {})),
    };
  }

  /**
   * Fired when user change login input field
   * Logins are lower cased to prevent future login error...
   * @param state 
   * @param event 
   */
  public onChangeLabel(state: ITemperatureState, event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.currentTarget.value;
    this.setState(({ temp }) => ({
      temp: {
        ...temp,
        label: value,
        modified: true,
      }
    }));
  }


  /**
   * Fired when user clicks on "Mail" checkbox
   * @param state 
   * @param event 
   */
  public onMailClick(state: ITemperatureState, event: React.MouseEvent<HTMLDivElement>) {
    const tmpTemp = this.state.temp;
    tmpTemp.mailAlert = tmpTemp.mailAlert === 1 ? 0 : 1,
      this.setState(({ temp }) => ({
        modified: true, temp: tmpTemp,

      }));
  }

  /**
   * Fired when user clicks on "Sms" checkbox
   * @param state 
   * @param event 
   */
  public onSmsClick(state: ITemperatureState, event: React.MouseEvent<HTMLDivElement>) {
    const tmpTemp = this.state.temp;
    tmpTemp.smsAlert = tmpTemp.smsAlert === 1 ? 0 : 1,
      this.setState(({ temp }) => ({
        modified: true, temp: tmpTemp,
      }));
  }

  /**
   * Fired when user clicks on "Push" checkbox
   * @param state 
   * @param event 
   */
  public onPushClick(state: ITemperatureState, event: React.MouseEvent<HTMLDivElement>) {
    const tmpTemp = this.state.temp;
    tmpTemp.pushAlert = tmpTemp.pushAlert === 1 ? 0 : 1,
      this.setState(({ temp }) => ({
        modified: true, temp: tmpTemp,
      }));
  }

  /**
   * Fired when user clicks on "Close" in selector
   * @param state 
   * @param event 
   */
  public onSelectorCloseClick(state: ITemperatureState, event: React.MouseEvent<HTMLDivElement>) {
    this.onChangeFromSelector(state, false);
  }

  /**
   * Repercute changes on the fly
   * @param state 
   * @param selectorShow 
   */
  public onChangeFromSelector(state: ITemperatureState, selectorShow: boolean) {
    if (this.state.selectorProperty === '' || this.state.selectorProperty === undefined) {
      this.setState({ selectorShow: false });
      return;
    }
    const tmp = this.state.temp;
    tmp[this.state.selectorProperty] = Math.round(this.state.selectorValue * 10) / 10;
    this.setState({ selectorShow, temp: { ...state.temp, tmp, modified: true, } });
  }

  /**
   * Fired when slider is moved
   * @param state 
   * @param value 
   */
  public onSelectorChange(state: ITemperatureState, value: number) {
    this.setState({ selectorValue: value, modified: true, }, () => {
      this.onChangeFromSelector(this.state, true);
    });
  }


  /**
   * Fired when user clicks on "Up" in selector
   * @param state 
   * @param event 
   */
  public onInputClick(property: string, min: number, max: number, step: number, event: React.MouseEvent<HTMLInputElement>) {
    this.setState({
      selectorLabel: this.props.i18n.Temperature[property + 'Short'],
      selectorMax: max,
      selectorMin: min,
      selectorProperty: property,
      selectorShow: true,
      selectorStep: step,
      selectorValue: this.state.temp[property],
    });
  }

  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    if (!this.state.modified || confirm(this.props.i18n.Common.confirmCancel)) {
      this.props.onGoBack();
    }
  }

  /**
   * Fired when user click on save button
   * @param event 
   */
  public onSaveClick(event: React.MouseEvent<HTMLDivElement>) {

    // Check temperatures thresehold
    if (this.state.temp.thresholdUp <= (this.state.temp.thresholdDown + this.state.temp.thresholdDelta)) {
      /* tslint:disable:no-empty */
      (navigator as INativeNavigator).notification.alert(this.props.i18n.Temperature.thresholdNotCorrect, () => { }, 'Smart TX');
      return;
    }

    // Only take different fields
    const channelWithChange = diffBetweenObject(this.props.temp, this.state.temp);
    this.props.onSaveTemperature(this.state.idDevice, this.props.site!.name, channelWithChange);
  }



  /**
   * Render React method
   */
  public render() {

    const i18n = this.props.i18n;

    if (this.props.temp === undefined) {
      window.location.pathname = '/';
      window.location.hash = '';
      return null;
    };

    return (
      <div className="standardPage temperature">
        <TitleBar
          leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
          onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
          title={this.state.temp.label}
          rightIcon={this.props.saving ? ITitleBar.ICO_CHECK_ROTATING : ITitleBar.ICO_CHECK}
          onRightButtonClick={this.onSaveClick.bind(this, this.state)}
        />

        <Selector label={this.state.selectorLabel}
          maxValue={this.state.selectorMax}
          minValue={this.state.selectorMin}
          step={this.state.selectorStep}
          onCloseClick={this.onSelectorCloseClick.bind(this, this.state)}
          onChange={this.onSelectorChange.bind(this, this.state)}
          show={this.state.selectorShow} value={this.state.selectorValue}
          unit='°C' />

        <ErrorMessage message={i18n.Common.errors[this.props.errorMessage]} />
        <div className="contentCentered">
          <div className="grid">
            {/* Temperature current value */}
            <div >
              <div className="thermostat">
                <div className="circle">
                  <span className={this.state.temp.inAlarm ? 'temp tempAlarm' : 'temp'}>{!isTemperaturInRange(this.state.temp.value) ? '---' : this.state.temp.value + '°C'}</span>
                </div>
              </div>
            </div>
            {/* Label */}
            <div>
              <InputText icon={IInputText.ICO_FONT} type="text" required={true} name={i18n.Temperature.label} id="label" isError={this.state.isLabelError} error={i18n.Common.errors.email} value={this.state.temp.label} onChange={this.onChangeLabel.bind(this, this.state)} />

            </div>
            {/* Threslhold */}
            <div className="rowThreshold" >
              <div>
                <InputText icon={IInputText.ICO_LEVEL_DOWN_ALT} type="text" required={true}
                  name={i18n.Temperature.thresholdDown} id="thresholdDown" isError={this.state.isThresholdDownError}
                  error={i18n.Common.errors.email} value={this.state.temp.thresholdDown.toString()}
                  onClick={this.onInputClick.bind(this, 'thresholdDown', -30, this.state.temp.thresholdUp - this.state.temp.thresholdDelta, 0.5)} />
              </div>
              <div>
                <InputText icon={IInputText.ICO_LEVEL_UP_ALT} type="text" required={true}
                  name={i18n.Temperature.thresholdUp} id="thresholdUp" isError={this.state.isThresholdUpError}
                  error={i18n.Common.errors.email} value={this.state.temp.thresholdUp.toString()}
                  onClick={this.onInputClick.bind(this, 'thresholdUp', this.state.temp.thresholdDown + this.state.temp.thresholdDelta, 60, 0.5)} />
              </div>
            </div>

            <div className="rowThreshold" >
              {/* Delta */}
              <div>
                <InputText icon={IInputText.ICO_DNA} type="text" required={true}
                  name={i18n.Temperature.thresholdDelta} id="thresholdDelta" isError={this.state.isDeltaError}
                  error={i18n.Common.errors.email} value={this.state.temp.thresholdDelta.toString()}
                  onClick={this.onInputClick.bind(this, 'thresholdDelta', 1, 10, 0.5)} />
              </div>
              {/* Calibration */}
              <div>
                <InputText icon={IInputText.ICO_PENCIL_ALT} type="text" required={true}
                  name={i18n.Temperature.thresholdCalibration} id="thresholdCalibration" isError={this.state.isCalibrationError}
                  error={i18n.Common.errors.email} value={this.state.temp.thresholdCalibration.toString()}
                  onClick={this.onInputClick.bind(this, 'thresholdCalibration', -2, 2, 0.1)} />
              </div>
            </div>

            <div className="alertTitle">
              {i18n.Common.alert}
            </div>
            <div className="rowAlert">
              <div><CheckBox
                checked={this.state.temp.mailAlert === 1} label={i18n.Media.mail} onClick={this.onMailClick.bind(this, this.state)} />
              </div>
              <div><CheckBox
                checked={this.state.temp.smsAlert === 1} label={i18n.Media.sms} onClick={this.onSmsClick.bind(this, this.state)} />
              </div><div><CheckBox
                checked={this.state.temp.pushAlert === 1} label={i18n.Media.push} onClick={this.onPushClick.bind(this, this.state)} />
              </div>
            </div>
          </div>
        </div>


      </div>

    );
  }
}

export default Temperature;


// WEBPACK FOOTER //
// ./src/pages/Temperature.tsx